// extracted by mini-css-extract-plugin
export var player = "SlidesEmbed-module--player--f4763";
export var slides = "SlidesEmbed-module--slides--ccd5f";
export var slideshare = "SlidesEmbed-module--slideshare--6fa87";
export var speakerdeck = "SlidesEmbed-module--speakerdeck--509df";